import { useState, useEffect } from 'react'
import * as querystring from 'query-string'
import SearchPage from './searchPage'
import { DEFAULT_FILTER, FINDACEPRO_BASE_URL } from '../constants.js';
import { fetchHelper } from '@ace/react-utilities';

const FindAnAcePro = (props) => {
    const queryStringParameters = querystring.parse(location.search)
    const [country, setCountry] = useState(queryStringParameters.country || "")
    const [radius, setRadius] = useState(queryStringParameters.radius || 0)
    const [zipCode, setZipCode] = useState(queryStringParameters.zipCode || "")
    const [province, setProvince] = useState(queryStringParameters.province || "")
    const [firstName, setFirstName] = useState(queryStringParameters.fname || "")
    const [lastName, setLastName] = useState(queryStringParameters.lname || "")
    const [results, setResults] = useState([])
    const [totalResults, setTotalResults] = useState(0)
    const [resultsPerPage, setResultsPerPage] = useState(12)
    const [sortBy, setSortBy] = useState(DEFAULT_FILTER)
    const [loading, setLoading] = useState(false)
    const [mostRecentSearchQuery, setMostRecentSearchQuery] = useState("")

    useEffect(() => {
        if (country) {
            searchByLocation()
        } else if (firstName && lastName) {
            namedSearch()
        }
    }, [])


    const setResultsToState = (data) => {
        setResults(data.Results.map((d, i) => {
            return { ...d, DistanceOrder: i }
        }))
        setTotalResults(data.TotalResults)
    }

    const buildUrl = (baseUrl, params) => {
        let url = baseUrl
        const parameterKeys = Object.keys(params)

        if (parameterKeys.length) {
            url = `${url}?` + parameterKeys.map(k => `${k}=${params[k]}`).join('&')
        }
        return url
    }

    const searchByLocation = () => {
        const parameters = {
            country: country,
            radius: radius,
            zipCode: country === "US" ? zipCode : "",
            province: country === "CA" ? province : "",
            lowerLimit: 0,
            upperLimit: resultsPerPage,
            sortBy: sortBy,
        }

        const searchQuery = {
            baseUrl: "/api/FindACEPro/",
            parameters: parameters
        }

        sendSearchRequest(searchQuery, "location")
    }

    const namedSearch = () => {
        const searchParameters = {
            lowerLimit: 0,
            upperLimit: resultsPerPage,
            firstName: firstName,
            lastName: lastName
        }

        const searchQuery = {
            baseUrl: FINDACEPRO_BASE_URL,
            parameters: searchParameters
        }

        sendSearchRequest(searchQuery, "name")
    }

    const sendSearchRequest = (searchQuery, searchType) => {
        setMostRecentSearchQuery(searchQuery)
        setLoading(true)
        const url = buildUrl(searchQuery.baseUrl, searchQuery.parameters)
        const options = { method: 'GET' }
        fetchHelper(url, options)
            .then(response => response.json())
            .then(data => {
                if (searchType === "name" && data.Results.length === 1) {
                    window.location.href = data.Results[0].ProfileURL
                } else {
                    setResultsToState(data)
                    setLoading(false)
                }
                setTimeout(function () {
                    document.getElementById("find-ace-pro-results").scrollIntoView()
                }, 1000);
            })
    }

    const updateSearch = (lowerLimit, upperLimit, sortBy) => {
        const searchQuery = mostRecentSearchQuery
        if (!searchQuery) {
            searchByLocation()
        } else {
            if (lowerLimit && upperLimit) {
                searchQuery.parameters.lowerLimit = lowerLimit
                searchQuery.parameters.upperLimit = upperLimit
            }

            if (sortBy) searchQuery.parameters.sortBy = sortBy

            const options = { method: 'GET' }
            const url = buildUrl(searchQuery.baseUrl, searchQuery.parameters)
            fetchHelper(url, options)
                .then(response => response.json())
                .then(data => {
                    setResultsToState(data)
                    setLoading(false)
                    document.getElementById("find-ace-pro-results").scrollIntoView()
                })
        }
    }

    const setSortByFunction = (sortBy) => {
        updateSearch(undefined, undefined, sortBy)
        setSortBy(sortBy)
    }

    return (
        <div>
            <SearchPage
                results={results}
                resultsPerPage={resultsPerPage}
                zip={zipCode}
                radius={radius}
                country={country}
                totalResults={totalResults}
                searchFunction={updateSearch}
                sortBy={sortBy}
                setSortByFunction={setSortByFunction}
                showLoadingIndicator={loading} />
        </div>
    )
}

export default FindAnAcePro